import React, { useState } from "react";
import Select, { TOption } from "../../../Components/Select";
import SunTriggerForm from "../../automations/triggers/SunTriggerForm";
import {
  defaultSunTrigger,
  defaultTimeTrigger,
  TSunTrigger,
  TTimeTrigger,
} from "../../automations/triggers/types";
import TimeTriggerForm from "../../automations/triggers/TimeTriggerForm";
import { useTranslation } from "react-i18next";

const defaultTimerTriggers = {
  time: defaultTimeTrigger,
  sun: defaultSunTrigger,
};

type TTimerTriggerType = "time" | "sun";

export type TTimerTrigger = TTimeTrigger | TSunTrigger;

interface ITimerTriggerProps {
  trigger: TTimerTrigger;
  onChange: (trigger: TTimerTrigger) => void;
}

const TimerTrigger = (props: ITimerTriggerProps) => {
  const { trigger, onChange } = props;
  const [initialTimerTrigger, setInitialTimerTrigger] =
    useState<TTimerTrigger>(trigger);
  const { t } = useTranslation();

  const timerTriggerTypeOptions: TOption<TTimerTriggerType>[] = [
    { value: "time", label: t("Time") },
    { value: "sun", label: t("Sun") },
  ];

  return (
    <>
      <Select
        fullWidth
        label={t("Trigger Type")}
        options={timerTriggerTypeOptions}
        value={initialTimerTrigger.type}
        onChange={(event) => {
          const newTrigger =
            defaultTimerTriggers[event.target.value as TTimerTriggerType];
          setInitialTimerTrigger(newTrigger);
          onChange(newTrigger);
        }}
      />
      {initialTimerTrigger.type === "time" && (
        <TimeTriggerForm trigger={initialTimerTrigger} onChange={onChange} />
      )}
      {initialTimerTrigger.type === "sun" && (
        <SunTriggerForm trigger={initialTimerTrigger} onChange={onChange} />
      )}
    </>
  );
};

export default TimerTrigger;
